export const REACT_LOCAL_APP_IMG_BASE_URL =
  "https://dh-dfs-local.s3.ap-south-1.amazonaws.com/";

export const REACT_APP_IMG_BASE_URL =
  "https://dh-dfs.s3.ap-south-1.amazonaws.com/";
